{
  "activities": {
    "accessoryProvider": "Fornecedor de Acessórios",
    "accessoryRawMaterialProvider": "Fornecedor de Matéria-Prima",
    "apparel": {
      "duvet": {
        "baffle": "Gola",
        "farm": "Reprodução",
        "materialProduction": "Matéria-Prima",
        "preProcessor": "Pré-processador"
      },
      "fabric": {
        "appret": "Acabamento",
        "coating": "Revestimento",
        "dyeing": "Tingimento/Estamparia",
        "lamination": "Laminação",
        "materialProduction": "Matéria-Prima",
        "spinning": "Fiação",
        "weavingKnitting": "Tecelagem/Tricô"
      },
      "leather": {
        "appret": "Acabamento",
        "dyeing": "Tintura",
        "farm": "Fazenda",
        "materialProduction": "Matadouro",
        "tanning": "Curtimento"
      },
      "manufacturing": "Fabricante",
      "yarn": {
        "dyeing": "Tintura",
        "materialProduction": "Matéria-Prima",
        "spinning": "Fiação"
      }
    },
    "brand": "marca",
    "certifiedEntity": "entidadeCertificada",
    "footwear": {
      "assembling": "Montagem",
      "finishing": "Acabamento",
      "stitching": "Costura"
    },
    "noActivity": "noActivity",
    "paper": {
      "assembling": "Montagem",
      "bleaching": "Branqueamento",
      "chemicalTreatment": "Tratamento químico",
      "laminating": "Laminação",
      "manufacturing": "Fabricação",
      "pressing": "Prensagem",
      "printing": "Impressão",
      "resineRemoving": "Remoção de resina",
      "whiteWashing": "Lavagem a branco"
    },
    "product": {
      "productWashing": "Lavagem de produto",
      "washing": "Lavagem"
    },
    "wood": {
      "assembling": "Montagem",
      "brushing": "Escovamento",
      "calibrationAndCollage": "Calibração e colagem",
      "harvesting": "Colheita",
      "manufacturing": "Fabricação",
      "materialDrying": "Secagem",
      "materialPeeking": "Seleção",
      "materialPeeling": "Descascamento",
      "materialSawing": "Serragem",
      "sanding": "Lixamento"
    }
  },
  "batchModal": {
    "actions": {
      "selectEmpty": "Selecionar apenas vazios"
    },
    "applyButton": "Aplicar {{type}} a {{ itemCount }} itens",
    "batchUpdateSuccess": "Atualização bem-sucedida",
    "batchUpdateSuccessMessage_one": "1 solicitação de informação foi atualizada",
    "batchUpdateSuccessMessage_many": "{{count}} solicitações de informação foram atualizadas",
    "batchUpdateSuccessMessage_other": "{{count}} solicitações de informação foram atualizadas",
    "info": "Há <b>{{count}}</b> outros itens com a atividade <b><activity/><b>",
    "labels": {
      "certificate": "Certificado",
      "clientName": "Nome do cliente",
      "componentName": "Nome do componente",
      "componentReference": "Referência do componente",
      "contact": "Contato",
      "documentProof": "Certificado de campo",
      "informationRequestItemReference": "Referência da Solicitação",
      "informationRequestItemReferenceHint": "Isso se refere à referência do item ao qual a solicitação de informação está associada (por exemplo, a referência do produto, material ou componente)",
      "materialName": "Nome do material",
      "materialProportion": "Proporção do material",
      "materialReference": "Referência do material",
      "productCollection": "Coleção de produtos",
      "productColor": "Cor do produto",
      "productId": "ID do produto",
      "productionSite": "Local de produção",
      "productName": "Nome do produto",
      "productReference": "Referência do produto",
      "purchaseOrder": "Pedido de compra",
      "purchaseOrderRef": "Referência do pedido",
      "reference": "Referência"
    },
    "noDocument": "Nenhum documento",
    "searchProduct": "Buscar produto",
    "title": "Aplicar esta ação a vários itens?"
  },
  "batchPopover": {
    "button": "Atualização em Lote...",
    "certificateText": "Aplicar este certificado a várias solicitações?",
    "text": "Aplicar esta {{key}} a vários <b> <activity /> </b>?"
  },
  "certificateBatchModal": {
    "labels": {
      "certificate": "Certificado",
      "products": "Produtos",
      "type": "Tipo"
    },
    "success_one": "{{count}} solicitação de certificado atualizada com sucesso",
    "success_many": "{{count}} solicitações de certificado atualizadas com sucesso",
    "success_other": "{{count}} solicitações de certificado atualizadas com sucesso"
  },
  "certificateRequestStatus": {
    "ACCEPTED": "Aceito",
    "OPENED": "Aberto",
    "REJECTED": "Rejeitado",
    "SUBMITTED": "Pendente"
  },
  "certificates": {
    "actions": {
      "delete": "Excluir",
      "submit": "Enviar",
      "transfer": "transferir"
    },
    "activityName": "Passo de rastreabilidade:",
    "labels": {
      "maxIssueDate": "Data de criação máxima",
      "purchaseOrder": "Pedido de compra ou número de fatura associado"
    },
    "modal": {
      "areyousure": "Tem certeza de que deseja excluir este certificado (esta ação é irreversível)?",
      "no": "Não",
      "yes": "Sim, Excluir"
    },
    "noRequests": {
      "closed": "Sem pedidos de certificado concluídos",
      "open": "Sem pedidos de certificado pendentes"
    },
    "productionSite": "Local de produção",
    "productionSitePending": "Informações do local de produção pendentes",
    "purchaseOrder": {
      "actions": {
        "seeLess": "Ocultar produtos",
        "seeMore": "Mostrar produtos"
      },
      "productReferences": "Referências do Produto"
    },
    "reference": "Referência: {{reference}}",
    "select": {
      "placeholder": "Selecione um documento dos seus carregamentos."
    },
    "upload": {
      "title": "Carregar certificado"
    }
  },
  "contactModal": {
    "businessPartnerRepository": {
      "addressUnavailable": "Morada indisponível",
      "createNewOption": "Criar novo: \"{{term}}\"",
      "prefillLoadError": "Não foi possível carregar os dados da empresa a partir do diretório. Ainda pode editar o formulário manualmente.",
      "prefillLoadErrorTitle": "Pré-preenchimento indisponível"
    },
    "labels": {
      "companyCity": "companyCity",
      "companyCityPlaceholder": "Paris",
      "companyCityTooltip": "Cidade da empresa",
      "companyCountry": "companyCountry",
      "companyCountryTooltip": "País da empresa",
      "companyIsActive": "Active",
      "companyIsActivePlaceholder": "Active",
      "companyIsActiveTooltip": "Identify business partners currently active and available for trade.",
      "companyName": "Nome da empresa",
      "companyNamePlaceholder": "Nome da empresa",
      "companyNameTooltip": "Nome público da empresa parceira.",
      "companyPostalCode": "Código postal da empresa",
      "companyPostalCodePlaceholder": "75001",
      "companyPostalCodeTooltip": "Código postal da empresa",
      "companyRegistrationId": "Company registration ID",
      "companyRegistrationIdDescription": {
        "DUNS": "Unique 9-digit identifier issued by Dun & Bradstreet, commonly used in the US and for international trade. Format: 9-digit numeric code.",
        "EORI": "Identification number for businesses involved in EU customs activities. Format: country code (e.g., FR) + 14-digit SIRET number.",
        "GLN": "Global Location Number - unique identifier for company locations or legal entities under GS1 standard. Format: 13-digit numeric code.",
        "OTHER": "Unique identifier of the company",
        "RCS": "RCS (numéro du registre du commerce): RCS + city + SIREN.",
        "VAT": "European tax identification number for companies liable to VAT. Format: country code (e.g., FR) + 2-digit key + 9-digit SIREN number."
      },
      "companyRegistrationIdPlaceholder": "1234567890",
      "companyRegistrationIdTooltip": "Número de identificação fiscal, CIN, GSTIN, USC, etc.",
      "companyRelationshipType": {
        "AGENT": "Agente",
        "BRAND": "Marca",
        "MANUFACTURER": "Fabricante",
        "OTHER": "Outro",
        "RAW_MATERIAL_SUPPLIER": "Fornitore de matéria prima",
        "SUPPLIER": "Fornecedor",
        "TRADER": "Comercializador"
      },
      "companyRelationshipTypeName": "Tipo",
      "companyRelationshipTypeTooltip": "Natureza da empresa parceira, utilizada para identificar seu papel na cadeia de aprovisionamento.",
      "companyStreet": "companyStreet",
      "companyStreetPlaceholder": "1 rue de Rivoli",
      "companyStreetTooltip": "Rua da empresa",
      "companySupplierCode": "Código do fornecedor",
      "companySupplierCodePlaceholder": "1234567890",
      "companySupplierCodeTooltip": "Short internal identification code for the business partner.",
      "contactInformation": "contactInformation",
      "coordinates": "coordinates",
      "coordinatesPlaceholder": "coordinatesPlaceholder",
      "email": "Endereço de e-mail",
      "emailPlaceholder": "johndoe@gmail.com",
      "emailTooltip": "Endereço de e-mail utilizado para contatar a empresa parceira.",
      "name": "Nome",
      "namePlaceholder": "John Doe",
      "nameTooltip": "Identificação usual do parceiro comercial, utilizada para trocas por e-mail.",
      "preferredLanguage": "Idioma preferido",
      "tags": "Tags",
      "tagsPlaceholder": "Adicionar tags...",
      "tagsTooltip": "Classificação interna, avaliação ou qualquer outra informação contextual."
    },
    "messages": {
      "create": {
        "error": "error",
        "success": "success"
      },
      "update": {
        "success": "success"
      }
    }
  },
  "contactSelect": {
    "labels": {
      "addNewContact": "Adicionar novo contato",
      "contact": "Contato",
      "you": "você"
    },
    "placeholders": {
      "contact": "Procurar por um contato"
    }
  },
  "contactTable": {
    "columns": {
      "activity": {
        "name": "Atividade",
        "tooltip": "Último login registrado do parceiro."
      },
      "averageResponseTime": {
        "averageResponseTimeValue_one": "{{nbDays}} dia",
        "averageResponseTimeValue_many": "averageResponseTimeValue",
        "averageResponseTimeValue_other": "{{nbDays}} dias",
        "name": "Tempo médio de resposta",
        "tooltip": "Tempo médio tomado para responder a solicitações de informações."
      },
      "certificateRequests": {
        "name": "Solicitações de certificados"
      },
      "code": {
        "name": "Código",
        "tooltip": "Código de identificação interno curto para o parceiro comercial."
      },
      "company": {
        "name": "Empresa",
        "tooltip": "Nome público oficial da empresa parceira comercial."
      },
      "contactEmail": {
        "name": "Contato (email)",
        "tooltip": "E-mail do contato principal dentro da empresa parceira."
      },
      "contactName": {
        "name": "Contato (nome)",
        "tooltip": "Nome do contato principal dentro da empresa parceira."
      },
      "location": {
        "name": "Localização",
        "tooltip": "País da empresa parceira comercial"
      },
      "productionSiteRequests": {
        "name": "Solicitações de sites de produção",
        "received": "recebidas"
      },
      "productionSites": {
        "name": "Sites de produção",
        "tooltip": "Contagem de sites declarados pelo parceiro comercial e contagem de países distintos."
      },
      "productRequests": {
        "name": "Solicitações de produtos"
      },
      "reminder": {
        "name": "Recordatorio",
        "tooltip": "Último recordatorio enviado ao parceiro."
      },
      "requests": {
        "name": "Solicitações",
        "tooltip": "Solicitações respondidas pelo parceiro."
      },
      "status": {
        "name": "Status",
        "tooltip": "Identifica parceiros comerciais atualmente ativos e disponíveis para comércio."
      },
      "tags": {
        "name": "Tags",
        "tooltip": "Classificação interna, classificação ou qualquer outra informação contextual."
      },
      "type": {
        "name": "Tipo",
        "tooltip": "Natureza da empresa parceira usada para identificar seu papel na cadeia de suprimentos."
      }
    },
    "status": {
      "active": "Ativo",
      "inactive": "Inativo"
    }
  },
  "customFields": {
    "attachment": "Anexo",
    "updateCustomField": {
      "customField": {
        "message": "O valor do campo personalizado foi atualizado e enviado para o cliente",
        "title": "Valor do campo personalizado atualizado"
      },
      "customFieldProof": {
        "message": "O certificado do campo personalizado foi enviado",
        "title": "Certificado do campo personalizado enviado"
      }
    },
    "uploadCustomFieldProofTooltip": "Solicitar um certificado digital para suportar o valor declarado"
  },
  "deselectAll": "Desmarcar Todos",
  "errors": {
    "axiosMessage": "O seguinte erro ocorreu: {{message}} \n\n por favor, tente novamente ou entre em contato com support@traceforgood.com se o erro persistir",
    "reinforcedTraceability": "Você não pode se atribuir a esta solicitação, por favor transfira para a pessoa relevante",
    "title": "Ocorreu um erro"
  },
  "filters": {
    "client": "Cliente",
    "search": "Buscar",
    "status": {
      "canceled": "Cancelado",
      "closed": "Fechado",
      "opened": "Aberto",
      "placeholder": "Estado"
    },
    "title": "Filtros",
    "type": "Tipo"
  },
  "item": {
    "brand": "Marca",
    "client": "Cliente",
    "collection": "Coleção",
    "color": "Cor",
    "component": "Componente",
    "date": "Data do pedido",
    "marketLaunchDate": "Data de Lançamento",
    "material_one": "Material",
    "material_other": "Materiais",
    "name": "Nome",
    "partOf": "Parte de",
    "product": "Produto",
    "purchaseOrderRef": "Número do Pedido",
    "reference": "Referência",
    "type": "Tipo"
  },
  "itemType": {
    "component": "Componente",
    "material": "Material",
    "product": "Produto"
  },
  "launch": {
    "modal": {
      "cancel": {
        "button": "button",
        "no": "no",
        "title": "title",
        "yes": "yes"
      },
      "close": {
        "button": "button"
      },
      "eligibleProducts": {
        "checkbox": "checkbox",
        "error": {
          "title": "title"
        },
        "infoBox": {
          "description": {
            "multiple": "multiple",
            "single": "single"
          },
          "title": {
            "multiple": "multiple",
            "single": "single"
          }
        },
        "launchButton": {
          "label": {
            "multiple": "multiple",
            "none": "none",
            "single": "single"
          }
        }
      },
      "fullTraceability": {
        "infoBox": {
          "description": "description",
          "title": "title"
        }
      },
      "header": {
        "description": {
          "default": "default",
          "noTraceabilityCampaign": "noTraceabilityCampaign",
          "runningJob": "runningJob"
        },
        "title": "title"
      },
      "pendingProducts": {
        "infoBox": {
          "description": {
            "multiple": "multiple",
            "single": "single"
          },
          "title": {
            "multiple": "multiple",
            "single": "single"
          }
        }
      },
      "success": {
        "button": "button",
        "description": "description",
        "title": "title"
      }
    }
  },
  "maxError": "Deve ser menor ou igual a {{max}}",
  "minError": "Deve ser maior ou igual a {{min}}",
  "operation": {
    "component": "Componente",
    "duplicateProductionSite": "Embora a submissão ainda seja possível, esteja ciente de que outras etapas foram declaradas neste site.",
    "material": "Material",
    "notOwner": "As informações já foram fornecidas por: {{email}}",
    "product": "Produto",
    "purchaseOrderRef": "Referência do Pedido",
    "reference": "Referência de {{type}} para seu fornecedor",
    "unknown": "outro contato"
  },
  "operationNotCreated": "Ocorreu um erro",
  "operationNotCreatedMessage": "A solicitação de informação para esta solicitação não foi criada ainda, por favor contate o suporte em support@traceforgood.com",
  "prodsiterequest": {
    "actions": {
      "transfer": "Transferir para outro contato",
      "transferAll": "Transferir tudo"
    },
    "noRequests": {
      "closed": "Você não tem pedidos concluídos.",
      "open": "Você não tem pedidos pendentes."
    },
    "status": {
      "INVALID": "Incompleto",
      "TOBESUBMITTED": "Pronto para enviar"
    },
    "transferModal": {
      "success_one": "{{count}} valor de solicitação do site de produção transferido com sucesso",
      "success_many": "{{count}} valores de solicitação do site de produção transferidos com sucesso",
      "success_other": "{{count}} valores de solicitação do site de produção transferidos com sucesso",
      "title": "Solicitação de transferência do site de produção",
      "transferButton": "Transferir"
    }
  },
  "productionSiteSelect": {
    "labels": {
      "addNewProductionSite": "Adicionar um novo local de produção",
      "productionSite": "Local de Produção"
    },
    "placeholders": {
      "productionSite": "Procurar por um local de produção"
    }
  },
  "reopenRequest": {
    "error": "Falha ao reabrir o pedido",
    "feedback_one": "{{count}} subpedido cancelado",
    "feedback_many": "feedback",
    "feedback_other": "{{count}} subpedidos cancelados",
    "title": "Tem certeza de que deseja reabrir este pedido? (esta ação cancelará todos os subpedidos deste pedido)",
    "yes": "Sim, tenho certeza!"
  },
  "request": {
    "complete": "Finalizar",
    "completeTooltip": "Clique aqui para concluir e fechar a solicitação. Quaisquer subsolicitações transferidas serão encaminhadas ao destinatário designado.",
    "errors": {
      "generic": "Ocorreu um erro. Por favor, tente novamente mais tarde."
    },
    "incomplete": "Incompleto",
    "labels": {
      "composition": "Composição",
      "requestDate": "Data da solicitação"
    },
    "readyToSubmit": "Pronto para enviar",
    "seeLess": "Ocultar pedido",
    "seeMore": "Mostrar pedido"
  },
  "requests": {
    "noRequests": {
      "closed": "Você não fechou nenhum pedido ainda.",
      "open": "Você não tem pedidos pendentes aguardando sua ação."
    },
    "tabs": {
      "canceled": "canceled",
      "certificates": {
        "scope": "Certificados de Escopo",
        "transaction": "Certificados de Transações"
      },
      "closed": "Concluídos",
      "prodsitefield": "Pedido de Local de Produção",
      "traceability": "Pedidos de Rastreabilidade"
    }
  },
  "requiredError": "Campo obrigatório",
  "selectAll": "Selecionar todos",
  "sorts": {
    "client": "Cliente",
    "dueDate": "Data de vencimento",
    "orderDate": "Data de pedido",
    "receptionDate": "Data de recepção da solicitação",
    "reference": "Referência"
  },
  "status": {
    "NOT_UPLOADED": "",
    "PROCESSED": "Carregado",
    "REJECTED": "",
    "UPLOADED": "Carregado"
  },
  "submitModal": {
    "composition": "Composição",
    "confidenceStatement": "Certifico solenemente que as informações fornecidas estão corretas e completas",
    "confirmation_one": "{{count}} pedido de rastreabilidade enviado com sucesso",
    "confirmation_many": "confirmation",
    "confirmation_other": "{{count}} pedidos de rastreabilidade enviados com sucesso",
    "error": "erro",
    "noRequests": "Você não tem pedidos completos para serem enviados nesta página",
    "reference": "Referência",
    "submitButton": "Confirmar ({{ itemCount }})",
    "title": "Selecione todos os pedidos que deseja enviar",
    "type": "Tipo"
  },
  "supplierSettings": {
    "filters": {
      "productionSite": "productionSite",
      "status": "Status",
      "tags": "Tags"
    }
  },
  "tooltips": {
    "contact": "contato",
    "productionSite": "Um local registrado em seu repositório onde ocorrem as operações de fabricação ou transformação. Cada site geralmente está associado a um único fluxo de produção, a menos que seja integrado com várias operações.",
    "purchaseOrderRef": "se você não tiver um pedido de compra para este {{type}}, você pode fornecer um número de fatura",
    "reference": "referência para identificar o item para seu fornecedor"
  },
  "transferModal": {
    "success": "Pedido de certificado transferido com sucesso",
    "title": "Selecione o contato ao qual transferir o certificado"
  },
  "uniqueActivitiesLabels": {
    "accessoryProvider": "Fornecedor de Acessórios",
    "accessoryRawMaterialProvider": "Fornecedor de Matéria-Prima",
    "apparel": {
      "duvet": {
        "baffle": "Gola",
        "farm": "Fazenda (edredão)",
        "materialProduction": "Matéria-prima (edredão)",
        "preProcessor": "Pré-processador"
      },
      "fabric": {
        "appret": "Acabamento (tecido)",
        "coating": "Revestimento (tecido)",
        "dyeing": "Tingimento/Estamparia (tecido)",
        "lamination": "Laminação",
        "materialProduction": "Matéria-prima (tecido)",
        "spinning": "Fiação (tecido)",
        "weavingKnitting": "Tecelagem/Tricô"
      },
      "leather": {
        "appret": "Acabamento (couro)",
        "dyeing": "Tintura (couro)",
        "farm": "Fazenda (couro)",
        "materialProduction": "Matadouro",
        "tanning": "Curtimento de couro"
      },
      "manufacturing": "Fabricação de vestuário",
      "yarn": {
        "dyeing": "Tintura (fios)",
        "materialProduction": "Matéria-prima (fios)",
        "spinning": "Fiação (fios)"
      }
    },
    "brand": "marca",
    "certifiedEntity": "entidadeCertificada",
    "footwear": {
      "assembling": "Montagem",
      "finishing": "Acabamento",
      "stitching": "Costura"
    },
    "noActivity": "noActivity",
    "paper": {
      "assembling": "Montagem de papel",
      "bleaching": "Branqueamento",
      "chemicalTreatment": "Tratamento químico",
      "laminating": "Laminação",
      "manufacturing": "Fabricação de papel",
      "pressing": "Prensagem",
      "printing": "Impressão",
      "resineRemoving": "Remoção de resina",
      "whiteWashing": "Lavagem a branco"
    },
    "product": {
      "productWashing": "Lavagem de produto",
      "washing": "Lavagem"
    },
    "wood": {
      "assembling": "Montagem de madeira",
      "brushing": "Escovamento",
      "calibrationAndCollage": "Calibração e colagem",
      "harvesting": "Colheita",
      "manufacturing": "Fabricação de madeira",
      "materialDrying": "Secagem",
      "materialPeeking": "Seleção",
      "materialPeeling": "Descascamento",
      "materialSawing": "Serragem",
      "sanding": "Lixamento"
    }
  }
}
